import { render } from "./ModalRemove.vue?vue&type=template&id=0aa712e7&scoped=true"
import script from "./ModalRemove.vue?vue&type=script&lang=js"
export * from "./ModalRemove.vue?vue&type=script&lang=js"

import "./ModalRemove.vue?vue&type=style&index=0&id=0aa712e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa712e7"]])

export default __exports__